import consentsData from './consents.json';

export interface ConsentItem {
  id: string;
  title: string;
  description: string;
  formattedDescription?: string;
  checkbox: string;
}

export type ConsentRecord = Record<string, ConsentItem>;

// Type assertion to ensure the JSON matches our interface
export const consents = consentsData as ConsentRecord;

export const ConsentConfig = {
  download: { advisor: [consents.advisorDownloadPolicyIllustration.id], client: [] },
  start: { advisor: [], client: [consents.clientReceiveDocsDigitally.id] },
  submit: {
    advisor: [
      consents.advisorAuthToDiscloseHealthInfo.id,
      consents.advisorCertificationOfAccuracy.id,
      consents.advisorBestInterestDisclosure.id,
      consents.advisorESignatureAndRecordsConsent.id,
    ],
    client: [
      consents.clientAuthToDiscloseHealthInfo.id,
      consents.clientCertificationOfAccuracy.id,
      consents.clientBestInterestDisclosure.id,
      consents.clientESignatureAndRecordsConsent.id,
    ],
  },
};

export const CarescoutConsentConfig = {
  ...ConsentConfig,
  start: { advisor: [], client: [consents.clientReceiveDocsDigitallyForCarescout.id] },
};
